<div class="certificate-parse-dialog-content"
     [formGroup]="parseForm">
  <ling-file-input
    formControlName="file"
    [maxFiles]="1"
    [disabledInput]="!!parseForm.controls.url.value"
    [acceptMimeType]="[documentMimeType.XLSX, documentMimeType.CSV]"
    label="{{ 'certificateForm.media.label' | translate }}"
    info="{{ 'certificateForm.media.info' | translate }}"
  ></ling-file-input>
  <p class="or">or</p>
  <div class="file-link-container">
    <ling-input
      formControlName="url"
      [disabledInput]="!!parseForm.controls.file.value?.length"
      label="{{ 'dialogs.parseCertificate.link.label' | translate }}"
      info="{{ 'dialogs.parseCertificate.link.info' | translate }}"
      placeholder="{{ 'dialogs.parseCertificate.link.placeholder' | translate }}"
    ></ling-input>
  </div>
</div>
<div class="action-buttons">
  <button mat-flat-button
          color="warn"
          [mat-dialog-close]="false"
  >{{ 'dialogs.parseCertificate.cancel' | translate }}
  </button>
  <button mat-flat-button
          color="primary" (click)="onSubmit()">{{ 'dialogs.parseCertificate.upload' | translate }}
  </button>
</div>
